export default "__VITE_ASSET__CKMq7KVo__"